import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EcoImg from 'eco-design/base/eco-img';
import React from 'react';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useCountDown } from 'ahooks';
import { useProductStore } from '@elem/compPage/stream-series-plug-in-solar-battery/ProductProvider';
import { IPageStatus } from '@elem/compPage/stream-series-plug-in-solar-battery/config/IPageStatus';
import useStatusLang from '../../StatusC/useStatusCLang';
import { isStatusC } from '../../utils';
import EcoSpace from 'eco-design/base/eco-space';
import { usePrice } from './usePrice';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';

const OnlineStoreRightsA5: React.FC = () => {
    const { t } = useStatusLang('theProduct.OnlineStoreRightsA3');
    const { locale } = getLocal();
    const { pageStatus } = useProductStore();
    const statusC = isStatusC();

    const { price, compareAtPrice } = usePrice(locale);

    return (
        <section
            id="OnlineStoreRightsA5"
            className={`${styles.OnlineStoreRightsA5} GtmModuleData-section`}
            data-section-id="OnlineStoreRightsA5"
            data-section-title={t('rights_title')}
        >
            <EcoSpace hPc="160px" hPad="100px" hH5="100px" bgColor={'#fefbf0'} />
            <div className="title">{t('rights_title')}</div>

            <div className="rights-container">
                <div className="rights">
                    <div className="item1 item">
                        <div className="top-desc">
                            <p className="up-to">{t('rights_desc_a_1')}</p>
                            <p className="persent">{t('rights_desc_a_2')}</p>
                        </div>
                        <div className="bottom-desc">{t('rights_desc_a_3')}</div>
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1749260658979/pc-right-item1-eu.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1749260658979/pc-right-item1-eu.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1749263319488/m-right-item1-eu.jpg"
                            isOpenLazy
                        />
                    </div>
                    <div className="item2 item">
                        <div className="desc">
                            <p className="gradient-text">{t('rights_desc_b_1')}</p>
                            <p className="text">{t('rights_desc_b_2')}</p>
                        </div>
                    </div>
                    <div className="item3 item">
                        <div className="desc">
                            <p className="title1">{t('rights_desc_c_1')}</p>
                            {pageStatus !== IPageStatus.statusC && <p className="time-desc">{t('rights_desc_c_2')}</p>}
                        </div>
                        <EcoImg
                            className={statusC ? 'statusc_img' : ''}
                            pc="https://websiteoss.ecoflow.com/upload/image/1749261844827/3-PC.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1749261844827/3-PC.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1749264677485/3-m.jpg"
                            isOpenLazy
                        />
                    </div>
                    {/* <div className="item4 item">
                        <div className="desc">
                            <p className="title1">{t('rights_desc_d_1')}</p>
                            <p className="subtitle1">{t('rights_desc_d_2')}</p>
                            <p className="time-desc">{t('rights_desc_d_3')}</p>
                        </div>
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1745410495713/pc-right-item3-eu.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1745410495713/pc-right-item3-eu.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1745410496303/m-right-item4-eu.jpg"
                        />
                    </div> */}
                    <div className="item5 item">
                        <div className="desc">
                            <div className="top-desc">
                                <p className="title1">{t('rights_desc_e_1') + ' ' + FormatMoneyLocal(price || 0, locale)}</p>
                                <p>
                                    <span className="price">{FormatMoneyLocal(price || 0, locale)}</span>
                                    <span className="underline-price">{FormatMoneyLocal(compareAtPrice || 0, locale)}</span>
                                </p>
                            </div>
                        </div>
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1750146054296/item5-pc.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1750146054296/item5-pc.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1749264691036/m-right-5-bg.jpg"
                            isOpenLazy
                        />
                    </div>
                    <div className="item7 item">
                        <div className="desc">
                            <p className="label">{t('rights_desc_g_1')}</p>
                            <p className="title">
                                <span>{t('rights_desc_g_2')}</span>
                                {locale === 'de' && <span className="suffix">{t('rights_desc_g_4')}</span>}
                            </p>
                        </div>
                        <div className="bottom">{t('rights_desc_g_3')}</div>
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1750145423992/item7-pc.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1750145423992/item7-pc.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1750144585645/item7-h5.png"
                            isOpenLazy
                        />
                    </div>
                    <div className="item6 item">
                        <div className="desc">
                            <p className="price">{t('rights_desc_f_1')}</p>
                            <p className="title1">{t('rights_desc_f_2')}</p>
                        </div>
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1749263184385/pc-right-item5-eu.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1749263184385/pc-right-item5-eu.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1750143975532/item6-h5.png"
                            isOpenLazy
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OnlineStoreRightsA5;
